/**
 * Converts the category present in the constants to that of the shop language corresponding to the collection in Shopify.
 * When more Shops are added, this function will need to be expande
 * @param {string} category The product's category
 * @returns {string} The category in the language of the shop
 */
export const toLocaleCategory = (category: string): string => {
  switch (category) {
    case 'dry_food':
      return 'trockenfutter';
    case 'wet_food':
      return 'nassfutter';
    case 'barf':
      return 'barf';
    case 'snacks':
      return 'snacks';
    case 'supplements':
      return 'nahrungserganzung';
    case 'health':
      return 'gesundheit';
    case 'cat_litter':
      return 'katzenstreu';
    case 'accessory':
      return 'accessory';
    default:
      return 'trockenfutter';
  }
};

/**
 * Converts the category in the constants to the one set in Shopify as the product type. This is currently in German, so there is a need for this conversion.
 * When more Shops are added, this function will need to be expande
 * @param {string} category The product's category
 * @returns {string} The product type we use in Shopify.
 */
export const toShopifyCategory = (category: string): string => {
  switch (category) {
    case 'dry_food':
      return 'Trockenfutter';
    case 'wet_food':
      return 'Nassfutter';
    case 'barf':
      return 'Frische-Menüs';
    case 'snacks':
      return 'Snacks';
    case 'supplements':
      return 'Nahrungsergänzung';
    case 'health':
      return 'Med';
    case 'cat_litter':
      return 'Zubehör';
    case 'accessory':
      return 'Zubehör';
    default:
      return 'Trockenfutter';
  }
};
